import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-185a839c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "headerContainer" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "headerRightContainer" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont iconEmergency icon-emergency-n" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-weibiaoti1" }, null, -1))
const _hoisted_6 = { class: "headerText" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon_down_arrow icon-houyigeyouzineirong" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont dropdownIcon icon-dizhi" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont dropdownIcon icon-youxiang" }, null, -1))
const _hoisted_10 = {
  style: {"max-width":"200px"},
  class: "omittingText"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-yuyan1" }, null, -1))
const _hoisted_12 = { class: "headerText" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon_down_arrow icon-houyigeyouzineirong" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-tuichu" }, null, -1))
const _hoisted_15 = { class: "logoutText" }

import {transformI18n, i18n} from '@/langs/i18n';
import {userLogout, userInfoGET} from '@/api/user';
import {removeToken} from '@/utils/auth';
import {useSettingStore} from '@/stores/setting';
import {computed, onMounted, ref} from 'vue';
import {defaultRoles} from '@/utils/defines';
import {useUserStore} from '@/stores/user';
import {getCountryObj} from '@/utils/countryList';
import {ElMessage} from 'element-plus';
import {sysCfgGet} from '@/api/sysCfg';
import EditPasswordDialog from './components/editPasswordDialog';
import VersionInfoDialog from './components/versionInfoDialog';
import PersonInfoDialog from './components/personInfoDialog';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useSettingStore();
const userStore = useUserStore();
const role = ref('');
const email = ref('');
const country = ref('');
const editPasswordDialogVisible = ref(false);
const versionInfoDialogVisible = ref(false);
const personInfoDialogVisible = ref(false);
const isEndUser = ref(false);
const agencyLevel = ref(0);
const agencyName = ref('');
const lang = computed(() => store.lang);
const webLogo = ref('');

const handleCommandUser = (command: string) => {
  if (command === 'editPassword') {
    editPasswordDialogVisible.value = true;
  } else if (command === 'versionInfo') {
    versionInfoDialogVisible.value = true;
  } else if (command === 'email') {
    copyVal(email.value);
  } else if (command === 'editPersonInfo') {
    personInfoDialogVisible.value = true;
  }
};

const copyVal = (copyText: string) => {
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(copyText).then(() => {
      ElMessage.success(transformI18n('common.copySuccess'));
    });
  } else {
    const textarea = document.createElement('textarea');
    textarea.setAttribute('readonly', 'readonly');
    textarea.value = copyText;
    document.body.appendChild(textarea);
    textarea.select();
    if (document.execCommand('copy')) {
      document.execCommand('copy');
      ElMessage.success(transformI18n('common.copySuccess'));
    }
    document.body.removeChild(textarea);
  }
};

const handleCommand = (command: string) => {
  i18n.global.locale.value = command;
  store.setLang(command);
};

const defaultCountryObj = computed(() => {
  const local: string = lang.value;
  let language = 'en';
  if (local === 'zh' || local === 'zh-cn') {
    language = 'zh';
  }
  return getCountryObj(language);
});

const userLogoutClick = async () => {
  try {
    await userLogout();
    removeToken();
    window.sessionStorage.clear();
    window.location.reload();
  } catch (e) {
    // do nothing.
  }
};

onMounted(() => {
  getUserInfo();
  getSysCfg();
});

const roleName = computed(() => {
  if (isEndUser.value) {
    return email.value;
  }
  if (role.value === defaultRoles.agency.name) {
    if (agencyLevel.value === defaultRoles.agency.installerLevel) {
      return agencyName.value || transformI18n('user.installer');
    }
  }
  return agencyName.value || transformI18n(defaultRoles[role.value]?.explain);
});

const getUserInfo = async () => {
  try {
    const res = await userInfoGET();
    role.value = res.data?.data?.user?.role;
    email.value = res.data?.data?.user?.email;
    country.value = res.data?.data?.user?.country;
    isEndUser.value = role.value === defaultRoles.user.name;
    agencyLevel.value = res.data?.data?.user.level;
    agencyName.value = res.data?.data?.user.agencyName;
    userStore.setUserInfo(res.data?.data?.user);
  } catch {
    // do nothing.
  }
};

const getSysCfg = async () => {
  try {
    const res = await sysCfgGet();
    webLogo.value = res.data.data?.picture?.webLogo;
    const sysName = res.data.data?.sysName || '';
    document.title = sysName;
    store.setSysName(sysName);
  } catch {
    // do nothing.
  }
};

const updatePersonInfo = ($event) => {
  personInfoDialogVisible.value = $event;
  getUserInfo();
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(EditPasswordDialog), {
      visible: editPasswordDialogVisible.value,
      "onUpdate:visible": [
        _cache[0] || (_cache[0] = ($event: any) => ((editPasswordDialogVisible).value = $event)),
        _cache[1] || (_cache[1] = ($event: any) => (editPasswordDialogVisible.value = $event))
      ]
    }, null, 8, ["visible"]),
    _createVNode(_unref(VersionInfoDialog), {
      visible: versionInfoDialogVisible.value,
      "onUpdate:visible": [
        _cache[2] || (_cache[2] = ($event: any) => ((versionInfoDialogVisible).value = $event)),
        _cache[3] || (_cache[3] = ($event: any) => (versionInfoDialogVisible.value = $event))
      ]
    }, null, 8, ["visible"]),
    _createVNode(_unref(PersonInfoDialog), {
      visible: personInfoDialogVisible.value,
      "onUpdate:visible": [
        _cache[4] || (_cache[4] = ($event: any) => ((personInfoDialogVisible).value = $event)),
        updatePersonInfo
      ]
    }, null, 8, ["visible"]),
    _createElementVNode("div", null, [
      (webLogo.value)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/",
            style: {"margin-left":"30px","display":"inline-block"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: webLogo.value,
                alt: "logo",
                style: {"height":"40px"}
              }, null, 8, _hoisted_2)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_el_dropdown, {
        onCommand: handleCommandUser,
        class: "organizationWrapper",
        placement: "bottom"
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, { class: "noClick" }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createTextVNode(" " + _toDisplayString(_unref(defaultCountryObj)[country.value]?.name), 1)
                ]),
                _: 1
              }),
              (!isEndUser.value)
                ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                    key: 0,
                    command: "email",
                    class: "copyText"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      _createElementVNode("span", _hoisted_10, _toDisplayString(email.value), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_dropdown_item, { command: "editPersonInfo" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(transformI18n)('user.personInfo')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, { command: "editPassword" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(transformI18n)('user.editPassword')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, { command: "versionInfo" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(transformI18n)('user.versionInfo')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", null, [
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(roleName)), 1),
            _hoisted_7
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_dropdown, {
        onCommand: handleCommand,
        placement: "bottom",
        class: "localWrapper"
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, {
                class: _normalizeClass({'is-active': _unref(lang) === 'zh'}),
                command: "zh"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('language.chinese')), 1)
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_el_dropdown_item, {
                class: _normalizeClass({'is-active': _unref(lang) === 'en'}),
                command: "en"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('language.english')), 1)
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", null, [
            _hoisted_11,
            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(transformI18n)('home.selectLanguage')), 1),
            _hoisted_13
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        link: "",
        onClick: userLogoutClick,
        class: "logoutWrapper"
      }, {
        default: _withCtx(() => [
          _hoisted_14,
          _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(transformI18n)('login.logout')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})